const locale = require('./navigation.i18n.json');

/*@ngInject*/
const NavigationController = function ($scope, $rootScope, $timeout, $sce, $state, $stateParams, $q, $window, coreConstant, currentSubmissionModel,
                                       formViewerConstant, submissionConstant, submissionMediator, wizardMediator, navigationItemType, currentUserModel, navigationUtil, quoteMediator, uiPerformanceLoggerConstant, appTypeConfigurationModel, formTemplateType) {

    let shouldUpdateSelectedNavigationItem = false;

    $scope.i18n = locale;

    $scope.viewModel = {
        showFormRenderingSpinner: false,
        selectedNavItem: null,
        isLoading: true
    };

    $scope.$on(coreConstant.event.HANDLE_ERROR, function (event, payload, logInfo) {
        shouldUpdateSelectedNavigationItem = false;
    });

    function init() {
        // Use the default child indexing to select the current nav item if we are loading into the submission without a saved state.
        loadNavItems($state.current.name === 'submission.default');
        quoteMediator.getQuoteList($stateParams.submissionId, $stateParams.proposalId);
    }

    function resetLongRequestTimer () {
        if($scope.longRequestTimer) {
            $timeout.cancel($scope.longRequestTimer);
            $rootScope.$broadcast(coreConstant.event.HIDE_LONG_REQUEST_WARNING);
        }
    }

    function loadNavItems(updateSelectedNavigationItem) {
        resetLongRequestTimer();

        $scope.longRequestTimer = $timeout(() => {
            $rootScope.$broadcast(coreConstant.event.SHOW_LONG_REQUEST_WARNING);
        }, 500);

        submissionMediator.getSubmissionNavItems($stateParams.submissionId).then(function (rootNavigationItem) {
            processNavItems(rootNavigationItem, updateSelectedNavigationItem);
            $scope.viewModel.isLoading = false;
            resetLongRequestTimer();
            $rootScope.$broadcast(coreConstant.event.HIDE_LONG_REQUEST_WARNING);
        });
    }

    function processNavItems(rootNavigationItem, updateSelectedNavigationItem) {
        function updateOverviewRouteIfNecessary() {
            let selectedItem = $scope.viewModel.selectedNavItem,
                isOverview = selectedItem.formTemplateType === formTemplateType.SUBMISSION,
                hasFormId = $stateParams.formId && parseInt($stateParams.formId) === selectedItem.ownerId;

            if (isOverview && !hasFormId) {
                $state.go('submission.form', {
                    submissionId: $stateParams.submissionId,
                    formId: selectedItem.ownerId
                });
            }
        }

        let currentState = $state.current.name,
            selectedNavItemType,
            subSelectionId,
            hasSubSelection,
            selectedNavItemId,
            updateState = false,
            currentlySelectedNavigationItem = $scope.viewModel.selectedNavItem;

        switch (currentState) {
            case 'submission.accountSubmissionsGrid':
                selectedNavItemType = navigationItemType.ACCOUNT_SUBMISSIONS;
                hasSubSelection = false;
                break;
            case 'submission.document':
                selectedNavItemType = navigationItemType.DOCUMENT;
                subSelectionId = parseInt($stateParams.attachmentId);
                hasSubSelection = true;
                break;
            case 'submission.quote':
                selectedNavItemType = navigationItemType.QUOTE;
                updateState = true;
                subSelectionId = parseInt($stateParams.quoteId);
                hasSubSelection = true;
                break
            case 'submission.quotes':
                selectedNavItemType = navigationItemType.QUOTES;
                hasSubSelection = false;
                break;
            case 'submission.proposals':
                selectedNavItemType = navigationItemType.PROPOSALS;
                hasSubSelection = false;
                break;
            case 'submission.reports':
                selectedNavItemType = navigationItemType.REPORTS;
                hasSubSelection = false;
                break;
            case 'submission.policies':
                selectedNavItemType = navigationItemType.POLICIES;
                hasSubSelection = false;
                break;
            case 'submission.policy':
                selectedNavItemType = navigationItemType.POLICY;
                updateState = true;
                subSelectionId = parseInt($stateParams.policyId);
                hasSubSelection = true;
                break;
            case 'submission.form':
            case 'submission.formSummaryGridDetail':
                selectedNavItemType = navigationItemType.FORM;
                subSelectionId = parseInt($stateParams.formId);
                hasSubSelection = true;
                break;
            case 'submission.externalContent':
                selectedNavItemType = navigationItemType.URL;
                subSelectionId = parseInt($stateParams.externalContentId);
                hasSubSelection = true;
                updateState = true; // Because the externalContent view uses a stateParam that isn't
                // explicit in the url (externalContentUrl and
                // externalContentPopoutUrl), we must 'refresh' the view to
                // make sure the externalContent view has all the parameters it
                // needs to render itself.
                break;
        }

        if(navigationUtil.getForcedServerSelectedNavItem(rootNavigationItem)){
            // Needed to ensure that when an entity with no actual display is selected, it's child is selected instead.
            updateState = true;
        }

        navigationUtil.generateIdForHierarchyLevel(rootNavigationItem.children, $scope.i18n);
        $scope.viewModel.selectedNavItem = navigationUtil.getSelectedNavItem(rootNavigationItem, currentState, selectedNavItemType, subSelectionId, hasSubSelection, updateSelectedNavigationItem, currentlySelectedNavigationItem);
        selectedNavItemId = _.clone($scope.viewModel.selectedNavItem.id);
        navigationUtil.openSelectedListToSelectedItem(rootNavigationItem.children, selectedNavItemId);

        if (updateSelectedNavigationItem || !navigationUtil.areNavigationItemsEqual(currentlySelectedNavigationItem, $scope.viewModel.selectedNavItem)) {
            const maintainFormSummaryGridDetail = currentState === 'submission.formSummaryGridDetail';

            changeRouteToSelectedNavItem($stateParams.submissionId, $scope.viewModel.selectedNavItem, maintainFormSummaryGridDetail);
        }
        updateOverviewRouteIfNecessary();

        $scope.viewModel.navigationList = rootNavigationItem.children;

        if (updateState) {
            $scope.onNavItemClicked(null, $scope.viewModel.selectedNavItem);
        }


        $scope.$broadcast(coreConstant.event.ADVANCE_FOCUS, '.' + $scope.viewModel.selectedNavItem.id, 200);

        if (!$scope.viewModel.selectedNavItem.enabled) {
            $rootScope.$broadcast(submissionConstant.event.REDIRECT_TO_OVERVIEW);
        }
    }

    function resetSelectedNavItem() {
        $scope.viewModel.selectedNavItem.selected = false;
    }

    function getContextType(contextType) {
        if (contextType === 'Submission') {
            contextType = submissionConstant.CONTEXT_SUBMISSION;
        } else if (contextType === 'Quote') {
            contextType = submissionConstant.CONTEXT_QUOTE;
        } else if (contextType === 'ExternalReport') {
            contextType = submissionConstant.CONTEXT_REPORT;
        } else if (contextType === 'PolicyIssuance') {
            contextType = submissionConstant.CONTEXT_POLICY_ISSUANCE;
        } else if (contextType === 'Policy') {
            contextType = submissionConstant.CONTEXT_POLICY;
        } else if (contextType === 'Proposal') {
            contextType = submissionConstant.CONTEXT_PROPOSAL;
        } else if (contextType === 'PolicyCancellation') {
            contextType = submissionConstant.CONTEXT_POLICY_CANCELLATION;
        } else if (contextType === 'Endorsement') {
            contextType = submissionConstant.CONTEXT_ENDORSEMENT;
        } else if (contextType === 'PolicyRewrite') {
            contextType = submissionConstant.CONTEXT_POLICY_REWRITE;
        }

        return contextType;
    }

    function getSelectedNavItemContext() {
        let contextType = '',
            contextId = 0,
            contextUri = '',
            context = {},
            hierarchicalContextList = [],
            contextLabel,
            selectedNavItem = $scope.viewModel.selectedNavItem;

        if (selectedNavItem && selectedNavItem.contextUri) {

            context = getContext(selectedNavItem.contextUri);
            contextId = context.contextId;
            contextType = context.contextType;
            contextUri = selectedNavItem.contextUri;

            contextType = getContextType(contextType);

            hierarchicalContextList = getHierarchicalContextList(selectedNavItem, contextId, contextType);
            contextLabel = getContextLabel(selectedNavItem);
        }

        return {
            contextId: contextId,
            contextType: contextType,
            contextLabel: contextLabel,
            contextUri: contextUri,
            hierarchicalContextList: hierarchicalContextList
        };
    }

    function getContext(contextUri) {
        let context = {},
            contextUriArray = _.remove(contextUri.split('/'), function (n) {
                return !_.isEmpty(n);
            });

        context.contextId = _.last(contextUriArray);
        context.contextType = _.first(contextUriArray);

        return context;
    }

    function getHierarchicalContextList(selectedNavItem) {
        let hierarchicalContextList = [],
            selectedNavItemIdArray = _.split(selectedNavItem.id, '-'),
            currentContextUri = '',
            currentContext = {},
            currentNavItem = {},
            duplicateContext = null;

        currentContext = getContext(selectedNavItem.contextUri);
        if (getContextType(currentContext.contextType) !== submissionConstant.CONTEXT_SUBMISSION) {
            hierarchicalContextList.unshift({
                contextType: submissionConstant.CONTEXT_SUBMISSION,
                contextId: $state.params.submissionId,
                contextUri: currentSubmissionModel.getCurrentSubmission().objectUri
            });
        }

        currentNavItem.children = $scope.viewModel.navigationList;

        _.each(selectedNavItemIdArray, function (selectedNavItemId) {
            currentNavItem = currentNavItem.children[selectedNavItemId];
            if (currentNavItem.contextUri !== currentContextUri) {
                currentContext = getContext(currentNavItem.contextUri);
                currentContextUri = currentNavItem.contextUri;
                duplicateContext = _.find(hierarchicalContextList, function(hierarchicalContext) {
                    return hierarchicalContext.contextId === currentContext.contextId && hierarchicalContext.contextType === getContextType(currentContext.contextType);
                });

                if (_.isNil(duplicateContext)) {
                    hierarchicalContextList.unshift({
                        contextId: currentContext.contextId,
                        contextType: getContextType(currentContext.contextType),
                        contextUri: currentNavItem.contextUri
                    });
                }

                duplicateContext = null;
            }
        });

        return hierarchicalContextList;
    }

    function getContextLabel(selectedNavItem) {
        let contextNavItem = navigationUtil.findOwnerUri($scope.viewModel.navigationList, selectedNavItem.contextUri);
        return contextNavItem ? contextNavItem.displayName : '';
    }

    function navigateToItem(navItem) {
        let submissionId = $stateParams.submissionId,
            hasChildren = navItem.children.length > 0,
            isPopoutUrlOnly = (!_.isNil(navItem.popoutUrl) && _.isNil(navItem.url)),
            isChangingState,
            trustedUrl,
            selectedNavItemId;

        if (isPopoutUrlOnly) {
            trustedUrl = $sce.trustAsResourceUrl(navItem.popoutUrl);
            $window.open(trustedUrl, '_blank');
        } else {
            isChangingState = changeRouteToSelectedNavItem(submissionId, navItem);

            $scope.viewModel.enableTreeArrowTransition = true;

            if (isChangingState) {
                resetSelectedNavItem();
                $scope.viewModel.selectedNavItem = navItem;
                $scope.viewModel.selectedNavItem.selected = true;
                selectedNavItemId = _.clone($scope.viewModel.selectedNavItem.id);
                navigationUtil.openSelectedListToSelectedItem($scope.viewModel.navigationList, selectedNavItemId);
            }
            else if (hasChildren) {
                $scope.openNavItemAndSelectDefault(null, navItem);
            }
        }

        return isChangingState;
    }

    $scope.openNavItemAndSelectDefault = function (event, navItem) {
        let selectedNavItemId;

        resetSelectedNavItem();
        $scope.viewModel.selectedNavItem = navigationUtil.getDefaultSelectedNavItem(navItem);
        selectedNavItemId = _.clone($scope.viewModel.selectedNavItem.id);
        navigationUtil.openSelectedListToSelectedItem($scope.viewModel.navigationList, selectedNavItemId);
        navItem.isOpen = true;
        changeRouteToSelectedNavItem($stateParams.submissionId, $scope.viewModel.selectedNavItem);
    };

    $scope.openNavItem = function (event, navItem) {
        $scope.viewModel.enableTreeArrowTransition = true;

        navItem.isOpen = !navItem.isOpen;

        if (event) {
            event.stopPropagation();
        }
    };

    $scope.onRequiredIndicatorClicked = function (event, navItem) {
        let isChangingState = navigateToItem(navItem);
        if (isChangingState) {
            $rootScope.$broadcast('showNextRequiredFieldAfterFormLoad');
            $rootScope.$broadcast(formViewerConstant.event.SHOW_NEXT_REQUIRED_FIELD_AFTER_FORM_LOAD);
        } else {
            $rootScope.$broadcast('showNextRequiredField');
            $rootScope.$broadcast(formViewerConstant.event.SHOW_NEXT_REQUIRED_FIELD, navItem.ownerId.toString());
        }
    };

    $scope.onNavItemClicked = function (event, navItem) {
        let isChangingState = navigateToItem(navItem);

        if (event) {
            event.stopPropagation();
        }

        return isChangingState;
    };

    $scope.getIdentifier = function (navItem) {
        return _.camelCase(navItem.displayName);
    };

    function changeRouteToSelectedNavItem(submissionId, selectedNavItem, maintainFormSummaryGridDetail) {
        let isChangingState,
            logAction,
            message,
            accountId,
            isNotCurrentSubmission = _.toInteger($state.params.submissionId) !== selectedNavItem.submissionId,
            isNotCurrentForm = _.toInteger($state.params.formId) !== selectedNavItem.ownerId;

        switch (selectedNavItem.type) {
            case navigationItemType.ACCOUNT_SUBMISSIONS:
                accountId = selectedNavItem.ownerUri ? _.split(selectedNavItem.ownerUri, ':', 2)[1] : null;
                if (isNotCurrentForm) {
                    isChangingState = true;
                }
                $state.go('submission.accountSubmissionsGrid', {
                    submissionId: submissionId,
                    accountId: accountId
                });
                break;

            case navigationItemType.DOCUMENT:
                message = 'Submission:' + submissionId + ',Attachment:' + selectedNavItem.ownerId;

                if (isNotCurrentSubmission || isNotCurrentForm) {
                    isChangingState = true;
                }

                $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.SHOW_DOCUMENT, message);

                $state.go('submission.document', {
                    submissionId: submissionId,
                    attachmentId: selectedNavItem.ownerId
                });
                break;

            case navigationItemType.FORM:
                logAction = uiPerformanceLoggerConstant.SHOW_FORM;
                message = 'formId:' + selectedNavItem.ownerId + ',watcherCount:' + getWatchersCount() + ',displayName:' + selectedNavItem.displayName;
                $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);

                if (isNotCurrentForm) {
                    isChangingState = true;
                }

                // If the state is actually changing, or if we don't care about maintaining the form summary grid detail
                // state...
                // We need this check in order to maintain the form summary grid detail route when reloading the application
                // when navigated to a form summary grid detail, because otherwise the navigation logic thinks that the
                // route is incorrect and we need to select the root form (since there are no sub-nav items for form
                // summary grid details)
                if (isChangingState || !maintainFormSummaryGridDetail) {
                    $state.go('submission.form', {
                        submissionId: submissionId,
                        formId: selectedNavItem.ownerId
                    });
                }
                break;

            case navigationItemType.QUOTES:
                if (isNotCurrentForm) {
                    isChangingState = true;
                }
                $state.go('submission.quotes', {
                    submissionId: submissionId
                });
                break;

            case navigationItemType.PROPOSAL:
                if (isNotCurrentForm) {
                    isChangingState = true;
                }
                $state.go('submission.proposal', {
                    submissionId: submissionId,
                    proposalId: selectedNavItem.ownerId
                });
                break;

            case navigationItemType.PROPOSALS:
                if (isNotCurrentForm) {
                    isChangingState = true;
                }
                $state.go('submission.proposals', {
                    submissionId: submissionId
                });
                break;

            case navigationItemType.REPORTS:
                if (isNotCurrentForm) {
                    isChangingState = true;
                }
                $state.go('submission.reports', {
                    submissionId: submissionId
                });
                break;

            case navigationItemType.POLICIES:
                if (isNotCurrentForm) {
                    isChangingState = true;
                }
                $state.go('submission.policies', {
                    submissionId: submissionId
                });
                break;

            case navigationItemType.POLICY:
                if (isNotCurrentForm) {
                    isChangingState = true;
                }
                $state.go('submission.policy', {
                    submissionId: submissionId,
                    policyId: selectedNavItem.ownerId
                });
                break;

            case navigationItemType.URL:
                if ($state.params.externalContentId !== selectedNavItem.ownerId) {
                    isChangingState = true;
                }
                $state.go('submission.externalContent', {
                    submissionId: submissionId,
                    externalContentId: selectedNavItem.ownerId,
                    externalContentUrl: selectedNavItem.url,
                    externalContentPopoutUrl: selectedNavItem.popoutUrl
                });
                break;
        }

        return isChangingState;
    }

    $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        const updateSelectedNavigationItem = !_.isNil(toParams.submissionId) &&
            toParams.submissionId === fromParams.submissionId &&
            toState.name === 'submission.default';
        if (updateSelectedNavigationItem) {
            loadNavItems(updateSelectedNavigationItem);
        }
    });

    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        $rootScope.$broadcast(coreConstant.event.HIDE_LONG_REQUEST_WARNING);
    });

    $scope.$on(submissionConstant.event.OPEN_OWNER_URI, function (event, ownerUri) {
        let selectedNavItem = navigationUtil.findOwnerUri($scope.viewModel.navigationList, ownerUri);
        if (selectedNavItem) {
            navigateToItem(selectedNavItem);
        }
    });

    $scope.$on(coreConstant.event.UPDATE_NAVIGATION_ITEM_MESSAGE, function (event, submissionUri, updatedNavigationItem, navigationItemActorPrincipalName) {
        let navigationItemMessageActorIsCurrentUser = currentUserModel.getCurrentUserSimplePrincipalId() === navigationItemActorPrincipalName,
            updateSelectedNavigationItem;

        $scope.viewModel.enableTreeArrowTransition = false;
        if ('/Submission/' + $stateParams.submissionId === submissionUri) {
            updateSelectedNavigationItem = (navigationItemMessageActorIsCurrentUser && (shouldUpdateSelectedNavigationItem || navigationUtil.isForceSelectionInNavigationTree(updatedNavigationItem)))
            processNavItems(updatedNavigationItem, updateSelectedNavigationItem);

            if (navigationItemMessageActorIsCurrentUser) {
                shouldUpdateSelectedNavigationItem = false;
            }
        }
    });

    $scope.$on(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM, function (event, ownerUri) {
        shouldUpdateSelectedNavigationItem = true;
    });

    $scope.$watch('viewModel.selectedNavItem', function (newValue, oldValue) {
        let selectedNavItemContext;
        if (((newValue || oldValue))) {
            selectedNavItemContext = getSelectedNavItemContext();
            wizardMediator.setContext(selectedNavItemContext);
            $rootScope.$broadcast(submissionConstant.event.CONTEXT_CHANGED, selectedNavItemContext);
        }
    });

    init();
};

angular.module('gw-um-submission')
    .controller('navigationController', NavigationController);
